const TitleH4 = ({
  className,
  title,
}: {
  className?: string;
  title: string;
}) => {
  return (
    <h4 className={`text-primary text-2xl font-normal ${className}`}>
      {title}
    </h4>
  );
};

export default TitleH4;
